import type { ReactNode } from "react";

type ServiceId = "founders" | "align" | "delivery" | "build";

export function ServiceIcon({ id }: { id: ServiceId }) {
  const common = {
    viewBox: "0 0 32 32",
    fill: "none",
    "aria-hidden": true as const,
  };

  const icons: Record<ServiceId, ReactNode> = {
    founders: (
      <svg {...common}>
        <circle cx="16" cy="11" r="4" stroke="currentColor" strokeWidth="1.75" />
        <path d="M8 26c1.5-4 5-6 8-6s6.5 2 8 6" stroke="currentColor" strokeWidth="1.75" />
      </svg>
    ),
    align: (
      <svg {...common}>
        <path d="M6 16h8M18 16h8M14 10v12" stroke="currentColor" strokeWidth="1.75" />
        <circle cx="16" cy="16" r="3" fill="currentColor" />
      </svg>
    ),
    delivery: (
      <svg {...common}>
        <path d="M6 22h20M8 18l4-8 4 5 4-9 4 12" stroke="currentColor" strokeWidth="1.75" />
      </svg>
    ),
    build: (
      <svg {...common}>
        <path
          d="M10 12 16 6l6 6v14H10V12Z"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  return <div className="service-icon">{icons[id]}</div>;
}
